import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  modalTitle,
  subtitle,
  buttonAccept,
  buttonCancel,
  buttonAcceptLoggedUser,
  buttonCancelLoggedUser
} = translate({
  "modalTitle": "Are you buying for your company?",
  "subtitle": "has got you covered !",
  "buttonAccept": "Create a Pro account",
  "buttonCancel": "Don't ask me again",
  "buttonAcceptLoggedUser": "Move to a Pro account",
  "buttonCancelLoggedUser": "I\u2019m not a pro"
});
export const offerInfo = translateFormatter<{
  span: RichTextFormatter;
  amount: string;
}>([{
  "type": 8,
  "value": "span",
  "children": [{
    "type": 1,
    "value": "amount"
  }, {
    "type": 0,
    "value": " off"
  }]
}, {
  "type": 0,
  "value": "* your first order, with this code"
}], undefined, undefined, "en");